<script>
import PopUp from '@/components/PopUp.vue'
import Switch from '@/components/Switch.vue'
import message from '@/helpers/message'
import config from "@/helpers/config"
import CalendarDays from '@/components/Calendar/CalendarDays.vue'
import niceFunctions from "@/helpers/niceFunctions"
import SvgTransition from '@/components/SvgTransition.vue'
import Loader from '@/components/Loader.vue'

export default {
    components: { PopUp, CalendarDays, Switch, SvgTransition, Loader },
    props: ['windowScroll'],
    data() {
        return {
            bookings: null,
            bookingItem: null,
            blockings: [],
            newBooking: {
                day: null,
                selected_date: null,
                isBlocked: false,
                start_time: null,
                end_time: null,
                startMinutes: null,
                endMinutes: null,
                id: 0,
                mobileNo: ''
            },
            showSummary: false,
            showConfirmation: false,
            showBookingBar: false,
            isSending: false
        }
    },
    created() {
        this.$cache.createCache('publicPage', 'public-page/', { id: this.$route.params.id, domain: window.location.hostname });
    },
    methods: {
        getBooking() {
            this.$communicator.get('add-public-booking/' + this.$route.params.bookingid)
                .then((data) => {
                    this.bookingItem = data.booking;
                    this.bookings = data.allBookings;
                    this.blockings = data.blockings;
                })
                .catch(function(error) {
                });
        },
        getTimeInMinutes(timeString) {
            if (timeString == null) {
                return null;
            }

            const [hours, minutes] = timeString.split(':').map(Number);
            return hours * 60 + minutes;
        },
        formatMinutes(minutes) {
            const hours = String(Math.floor(minutes / 60)).padStart(2, '0');
            const mins = String(minutes % 60).padStart(2, '0');
            return `${hours}:${mins}`;
        },
        getSlotEndMinutes(time) {
            return this.bookingItem.hour_calender_layout == 'Timmar' ? time.minutes + 60 : time.minutes + 30;
        },
        selectTime(time) {
            if (this.checkIfOccupied(time)) {
                return;
            }

            message.removeMessage();

            if (this.newBooking.start_time == null) {
                this.newBooking.start_time = time.timeLabel;
                this.newBooking.startMinutes = time.minutes;
                return;
            }

            if (time.minutes < this.newBooking.startMinutes) {
                return;
            }

            const endMinutes = this.getSlotEndMinutes(time);
            if (endMinutes - this.newBooking.startMinutes > this.bookingItem.duration_time * 60) {
                message.setInfoMessage("Du har valt en längre bokningstid än vad som är möjligt. Maximal bokningstid är " + this.bookingItem.duration_time + " " + this.bookingItem.duration_unit);
                return;
            }

            if (this.occupiedTimesSelectedDay.some(x => this.newBooking.startMinutes < x.end_time_in_minutes && endMinutes > x.start_time_in_minutes)) {
                message.setInfoMessage("Du har valt en tid som ligger över en annan bokning eller blockering. Vänligen ändra tid.");
                return;
            }

            this.newBooking.end_time = time.timeLabelEndTime;
            this.newBooking.endMinutes = endMinutes;
        },
        checkIfOccupied(time) {
            const slotEndMinutes = this.getSlotEndMinutes(time);
            return this.occupiedTimesSelectedDay.some(x => time.minutes < x.end_time_in_minutes && slotEndMinutes > x.start_time_in_minutes);
        },
        getOccupiedEntry(time) {
            const slotEndMinutes = this.getSlotEndMinutes(time);
            const firstSlotMinutes = this.timeSlots[0]?.minutes;
            return this.occupiedTimesSelectedDay.find(x => {
                const startsInSlot = x.start_time_in_minutes >= time.minutes && x.start_time_in_minutes < slotEndMinutes;
                const continuesIntoFirstSlot = firstSlotMinutes === time.minutes && x.start_time_in_minutes < time.minutes && x.end_time_in_minutes > time.minutes;
                return startsInSlot || continuesIntoFirstSlot;
            });
        },
        isBlockingEntry(time) {
            const slotEndMinutes = this.getSlotEndMinutes(time);
            return this.occupiedTimesSelectedDay.find(x => time.minutes < x.end_time_in_minutes && slotEndMinutes > x.start_time_in_minutes)?.isBlocking === true;
        },
        getOccupiedTime(time) {
            const occupiedTime = this.getOccupiedEntry(time);
            if (occupiedTime) {
                if (occupiedTime.isBlocking) {
                    const description = occupiedTime.description ? ' - ' + occupiedTime.description : '';
                    return '<b>' + occupiedTime.formatted_start_time + ' - ' + occupiedTime.formatted_end_time + '</b> Blockering' + description;
                }
                return '<b>' + occupiedTime.formatted_start_time + ' - ' + occupiedTime.formatted_end_time + '</b> ' + occupiedTime.full_name;
            }
            return '';
        },
        getNewBookingStartTime(time) {
            if (time.minutes == this.newBooking.startMinutes) {
                return this.newBooking.start_time + ' - ' + (this.newBooking.end_time ?? '');
            }
        },
        isSelectedTime(time) {
            if (time.minutes == this.newBooking.startMinutes) {
                return true;
            }

            if (this.newBooking.endMinutes) {
                return time.minutes > this.newBooking.startMinutes && time.minutes < this.newBooking.endMinutes;
            }
            return false;
        },
        setNewStartTime() {
            this.newBooking.start_time = null;
            this.newBooking.end_time = null;
            this.newBooking.endMinutes = null;
            this.newBooking.startMinutes = null;
        },
        save() {
            message.removeMessage();

            var validationErrors = [];

            if (!this.newBooking.full_name) {
                validationErrors.push("Du behöver mata in ett namn.");
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!this.newBooking.email || !emailRegex.test(this.newBooking.email)) {
                validationErrors.push("Du behöver mata in en korrekt email.");
            }

            if (!this.newBooking.agree_to_terms) {
                validationErrors.push("Du behöver bekräfta att du tagit del av informationen som berör bokningen.");
            }

            if (validationErrors.length > 0) {
                message.setValidationErrorMessage(validationErrors);
                return;
            }

            this.newBooking.booking_item_id = this.bookingItem.id;
            this.newBooking.start_date = this.newBooking.selected_date + ' ' + this.newBooking.start_time;
            this.newBooking.end_date = this.newBooking.selected_date + ' ' + this.newBooking.end_time;
            this.newBooking.customer_name = this.customerName;
            this.newBooking.booking_item_name = this.bookingItem.name;

            this.isSending = true;
            this.$communicator.post('add-public-booking/', this.newBooking)
                .then((data) => {
                    this.getBooking();
                    this.isSending = false;
                    this.showConfirmation = true;
                })
                .fail((error) => {
                    this.isSending = false;
                    if (error.responseJSON.detail == 'already booked') {
                        message.setValidationErrorMessage(["Du har redan en aktiv bokning registerad. Du kan endast ha en bokning registrerad i taget."]);
                    }
                    else if (error.responseJSON.detail == 'max duration exceeded') {
                        message.setValidationErrorMessage(["Du har valt en längre bokningstid än vad som är möjligt. Vänligen välj en kortare bokningstid."]);
                    }
                })
        },
        closeConfirm() {
            this.$router.push({ name: niceFunctions.getPageName('home'), params: { id: this.$route.params.id } });
        },
    },
    computed: {
        timeSlots() {
            const slots = [];
            for (let hours = this.bookingItem.day_available_start_hour; hours < this.bookingItem.day_available_end_hour; hours++) {
                if (this.bookingItem.hour_calender_layout == "Timmar") {
                    slots.push({ timeLabel: `${String(hours).padStart(2, '0')}:00`, timeLabelEndTime: `${String(hours + 1).padStart(2, '0')}:00`, minutes: hours * 60 });
                }
                else {
                    slots.push({ timeLabel: `${String(hours).padStart(2, '0')}:00`, timeLabelEndTime: `${String(hours).padStart(2, '0')}:30`, minutes: hours * 60 });
                    slots.push({ timeLabel: `${String(hours).padStart(2, '0')}:30`, timeLabelEndTime: `${String(hours + 1).padStart(2, '0')}:00`, minutes: hours * 60 + 30 });
                }
            }
            return slots;
        },
        bookingsSelectedDay() {
            if (this.newBooking.date == null) {
                return [];
            }
            return (this.bookings ?? []).filter(x => x.formatted_start_date == this.newBooking.date.toLocaleDateString('sv-SE'));
        },
        blockingsSelectedDay() {
            if (this.newBooking.date == null || this.bookingItem == null) {
                return [];
            }

            const dayStart = new Date(this.newBooking.date.getFullYear(), this.newBooking.date.getMonth(), this.newBooking.date.getDate(), 0, 0, 0, 0);
            const dayEnd = new Date(this.newBooking.date.getFullYear(), this.newBooking.date.getMonth(), this.newBooking.date.getDate() + 1, 0, 0, 0, 0);
            const availabilityStart = this.getTimeInMinutes(this.bookingItem.day_available_start_time);
            const availabilityEnd = this.getTimeInMinutes(this.bookingItem.day_available_end_time);

            return (this.blockings ?? [])
                .map(blocking => {
                    const blockingStart = new Date(blocking.start_date);
                    const blockingEnd = new Date(blocking.end_date);

                    if (blockingEnd <= dayStart || blockingStart >= dayEnd) {
                        return null;
                    }

                    const rangeStart = blockingStart > dayStart ? blockingStart : dayStart;
                    const rangeEnd = blockingEnd < dayEnd ? blockingEnd : dayEnd;
                    const rangeStartMinutes = rangeStart.getTime() <= dayStart.getTime() ? 0 : rangeStart.getHours() * 60 + rangeStart.getMinutes();
                    const rangeEndMinutes = rangeEnd.getTime() >= dayEnd.getTime() ? 24 * 60 : rangeEnd.getHours() * 60 + rangeEnd.getMinutes();
                    const clampedStartMinutes = Math.max(rangeStartMinutes, availabilityStart ?? 0);
                    const clampedEndMinutes = Math.min(rangeEndMinutes, availabilityEnd ?? 24 * 60);

                    if (clampedEndMinutes <= clampedStartMinutes) {
                        return null;
                    }

                    return {
                        start_time_in_minutes: clampedStartMinutes,
                        end_time_in_minutes: clampedEndMinutes,
                        formatted_start_time: this.formatMinutes(clampedStartMinutes),
                        formatted_end_time: this.formatMinutes(clampedEndMinutes),
                        description: blocking.description,
                        isBlocking: true
                    };
                })
                .filter(blocking => blocking != null);
        },
        occupiedTimesSelectedDay() {
            return [...this.bookingsSelectedDay, ...this.blockingsSelectedDay]
                .sort((a, b) => a.start_time_in_minutes - b.start_time_in_minutes);
        },
        url() { return config.urlToServer },
        publicPage() { return this.$store.state.publicPage != null ? this.$store.state.publicPage.publicPage : null },
        height() { return window.innerHeight / 1.3 + 'px' },
        customerName() { return this.$store.state.publicPage != null ? this.$store.state.publicPage.customerName : {} },
        smsNotificationEnabled() { return this.$store.state.publicPage != null ? this.$store.state.publicPage.smsNotificationEnabled : null },
        publicPageColorsDict() { return this.$store.state.publicPage != null ? this.$store.state.publicPage.publicPageColorsDict : null },
    },
    watch: {
        "$route.params.bookingid": {
            handler: function(value) {
                if (value != undefined) {
                    this.getBooking();
                }
            },
            deep: true,
            immediate: true,
        },
        windowScroll(newvalue) {
            if ($("#BookingHours-calendar")[0] == undefined) {
                return false;
            }

            if (newvalue > $("#BookingHours-calendar")[0].offsetTop - window.innerHeight) {
                this.showBookingBar = true;
            }
            else {
                this.showBookingBar = false;
            }
        },
        "newBooking.day"(day) {
            if (this.$isMobile) {
                if (day != null) {
                    this.$nextTick(() => {
                        $("html, body").animate({
                            scrollTop: $("#BookingHours-times").offset().top
                        })
                    })
                }
            }
        }

    }
}
</script>
<template>
    <div class="public-page" v-if="bookingItem != null && publicPage != null" v-fade-in :style="{ '--background-color': publicPageColorsDict.background_color.color }">
        <div class="top-public position-relative" :style="{ 'background-image': bookingItem.image_name != null ? 'url(' + url + 'uploads/'+ publicPage.customer_id+'/images/'+ bookingItem.image_name + ')' : '', 'height': height }">
            <SvgTransition :publicPage="publicPage"></SvgTransition>
        </div>
        <div class="text-section" v-fade-in>
            <h1 :style="publicPageColorsDict.header_color_on_white_bg.style">{{ bookingItem.name }}</h1>
            <p>Max bokningtid: {{ bookingItem.duration_time }} timmar</p>
            <div class="margin-top-15" v-html="this.$adaptHtml.adaptHtml(bookingItem.information, publicPageColorsDict.header_color_on_white_bg, publicPageColorsDict.background_color.color)"></div>
            <div class="info BookingAdd-info-box" :style="{ 'background-color': publicPageColorsDict.background_color.color + ' !important', 'filter': 'brightness(90%)' }">
                <b style="text-transform: uppercase;">Läs igenom följande information innan du bokar:</b>
                <div class="margin-top-15" v-html="this.$adaptHtml.adaptHtml(bookingItem.rules, publicPageColorsDict.header_color_on_white_bg, publicPageColorsDict.background_color.color)"></div>
                <p>Max bokningtid: {{ bookingItem.duration_time }} timmar</p>
            </div>
            <div class="g-70" id="BookingHours-calendar">
                <div class="g-100 text-right">
                    <i class="fa-solid fa-circle" style="color: rgb(189 162 162)"></i> = blockering
                </div>
                <CalendarDays :bookings="bookings" :blockings="blockings" :selectedDay="newBooking" :bookingItem="bookingItem"></CalendarDays>
            </div>
            <div id="BookingHours-times" class="g-30">

                <div class="BookingHours-calendar-position" v-if="newBooking.day != null" v-fade-in :class="bookingItem.hour_calender_layout == 'Timmar' ? 'BookingHour-only-hours' : ''">
                    <div class="overflow-auto" style="padding-top:5px;">
                        <div class="g-10">
                            <div v-for="(time, index) in timeSlots" :key="time.minutes" class="time-label" :style="{ 'border-top-style': index % 2 === 1 ? 'dashed' : '' }">
                                <span>{{ index % 2 === 0 || bookingItem.hour_calender_layout == 'Timmar' ? time.timeLabel : '' }}</span>
                            </div>
                        </div>
                        <div class="g-90">
                            <div v-for="(time,index) in timeSlots" :key="time.minutes + '-slot'" class="time-slot" :style="{ 'border-top-style': index % 2 === 1 ? 'dashed' : '' }" :class="[checkIfOccupied(time) ? 'occupied' : '', isBlockingEntry(time) ? 'occupied-blocking' : '', isSelectedTime(time) ? 'selected-time-slot' : '']" @click="selectTime(time)">
                                <span v-if="getOccupiedEntry(time)" v-html="getOccupiedTime(time)" class="occupied occupied-label" :class="{ 'occupied-blocking': isBlockingEntry(time) }"></span>
                                <span v-html="getNewBookingStartTime(time)"></span>
                            </div>
                        </div>
                    </div>
                    <div class="BookingHours-end-hour"><span>{{bookingItem.day_available_end_time}}</span></div>
                </div>
            </div>
            <div class="BookingHours-booking-times" v-if="showBookingBar" v-fade-in>
                <div>
                    1. Välj datum
                    <h2> {{ newBooking.selected_date }} </h2>
                </div>
                <div>
                    <span :style="{ 'opacity': newBooking.selected_date == null ? '0.3' : '1', 'margin': '0px'}">2. Välj Starttid</span>
                    <h2>{{newBooking.start_time }} <button class="btn btn-gray" v-if="newBooking.start_time != null" @click="setNewStartTime">Ändra starttid</button></h2>
                </div>
                <div>
                    <p :style="{ 'opacity': newBooking.start_time == null ? '0.3' : '1', 'margin': '0px'}" class="margin-top-15">
                        3. Välj Sluttid
                    </p>
                    <h2>{{newBooking.end_time }}</h2>
                </div>
                <div class="pc-only">
                    <button class="btn margin-top-15 BookingHours-confirm-btn" v-if="newBooking.end_time != null" @click="showSummary = true">Slutför bokningen</button>
                </div>
                <button class="btn mobile-only margin-top-15 BookingHours-confirm-btn mobile-100w-btn" v-if="newBooking.end_time != null" @click="showSummary = true">Slutför bokningen</button>
            </div>
        </div>
    </div>
    <div class="loader" v-else v-fade-in>
        <div>
            <Loader></Loader>
            <div style="margin-top: -30px;">Laddar sidan</div>
        </div>
    </div>
    <div v-if="showSummary && !showConfirmation">
        <PopUp>
            <h2>Bokning av {{ bookingItem.name }} | {{ newBooking.selected_date }} {{ newBooking.start_time }} - {{ newBooking.selected_date }} {{ newBooking.end_time }}</h2>
            <label>Ditt namn (kommer synas i bokningskalendern)<span style="font-family: 'Courier New', Courier, monospace;">*</span></label>
            <input type="text" v-model="newBooking.full_name" style="border: 1px solid #ddd" />
            <div class="row-form">
                <div class="g-50" :class="smsNotificationEnabled ? 'g-50' : 'g-100'">
                    <label>Din email (Hit skickas ett bekräftelsemail)<span style="font-family: 'Courier New', Courier, monospace;">*</span></label>
                    <input type="text" v-model="newBooking.email" style="border: 1px solid #ddd" />
                </div>
                <div class="g-50" v-if="smsNotificationEnabled">
                    <label>Ditt mobilnummer (Mata in om du vill ha bekräftelse och påminnelse via sms)</label>
                    <div class="position-relative">
                        <input type="text" v-model="newBooking.mobileNo" style="border: 1px solid #ddd; padding-left: 123px; width: calc(100% - 135px);" />
                        <div class="flag-area">
                            <svg width="40" height="28" viewBox="0 0 16 11.2" xmlns="http://www.w3.org/2000/svg">
                                <rect width="16" height="11.2" fill="#005cbf" />
                                <rect x="5" width="1.6" height="11.2" fill="#fecc00" />
                                <rect y="4.8" width="16" height="1.6" fill="#fecc00" />
                            </svg>
                            <div style="padding: 1px 7px 0px 7px;">+46</div>
                            <div style="padding: 0px 7px 0px 1px;">&#x25BC;</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="info BookingAdd-info-box" :style="{ 'background-color': publicPageColorsDict.background_color.color + ' !important', 'filter': 'brightness(90%)' }">
                <Switch :model="newBooking" :prop="'agree_to_terms'"></Switch>
                <b style="text-transform: uppercase;">&nbsp; Jag bekräftar att jag tagit del av informationen som berör bokningen</b>
            </div>
            <div class="margin-top-15 float-right">
                <button class="btn btn-gray" style="padding: 10px" @click="showSummary = false">Gå tillbaka och ändra i bokningen</button>
                <button class="btn" :style="{ 'background-color': publicPageColorsDict.background_color.color + ' !important', 'filter': 'brightness(90%)','padding': '10px' }" @click="save">Slutför bokningen</button>
            </div>
        </PopUp>
    </div>
    <div v-if="showConfirmation">
        <PopUp :width="this.$isMobile ? '90%' : '600px'" :top="'60px'">
            <div style="text-align: center;">
                <h2>Härligt! Bokningen av {{ bookingItem.name }} mellan {{ newBooking.selected_date }} {{ newBooking.start_time }} - {{ newBooking.selected_date }} {{ newBooking.end_time }} lyckades!</h2>
                Inom kort får du ett bekräftelsemail skickat till {{ newBooking.email }} (Håll utkik i skräppkorgen ifall den olyckligtvis hamnat där). <br><span style="font-size: 51pt; display: block">&#127870;</span> <br><strong>Vi ses snart! </strong> <br>

                <button class="btn" :style="{ 'background-color': publicPageColorsDict.background_color.color + ' !important', 'filter': 'brightness(90%)','padding': '10px', 'margin': '30px 0px' }" @click="closeConfirm"> Tillbaka till startsidan</button>
            </div>
        </PopUp>
    </div>
    <div v-if="isSending">
        <PopUp :width="this.$isMobile ? '90%' : '600px'" :top="'60px'">
            <div style="text-align: center;">
                <span style="font-size: 70px;"> &#x1F680;</span><br>
                Genomför bokningen . . .
            </div>
        </PopUp>
    </div>
</template>
<style scoped>
.BookingAdd-info-box
{
    padding:25px;
    margin-bottom: 15px;
    margin-top: 23px;
}

.loader {
    min-height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.text-section {
    overflow: auto;
    padding-bottom: 108px;
}

.time-slot {
    height: 17px;
    border-top: 1px solid #ddd;
    padding: 0px 10px;
    font-size: 12px;
    cursor:pointer;
    position:relative;
}

.time-slot:hover {
    opacity: 0.7;
    background: rgb(154, 217, 154);
}

.time-label {
    height: 17px;
    border-top: 1px solid #ddd;
    text-align: center;
    font-size: 12px;
}

.BookingHours-end-hour {
    height: 17px;
    border-top: 1px solid #ddd;
    font-size: 12px;
    margin-left: 4px;
}

.time-label span, .BookingHours-end-hour span {
    margin-top: -10px;
    display: block;
    width: 40px;
    background: white;
}

.BookingHour-only-hours .time-label, .BookingHour-only-hours .time-slot {
    height: 34px;
}

.BookingHour-only-hours .g-10 {
    width: 52px !important;
}

.BookingHour-only-hours .g-90 {
    width: calc(100% - 52px) !important;
}

.occupied {
    background: rgb(245, 150, 150);
    border-top: 1px solid rgb(245, 150, 150);
}

.occupied-blocking {
    background: rgb(189 162 162);
    border-top: 1px solid rgb(189 162 162);
}

.occupied-label {
    display: block;
}

.selected-time-slot {
    border-top: 1px solid rgb(154, 217, 154);
    background: rgb(154, 217, 154) !important;
}

.BookingHours-booking-times
{
    padding:14px 10px 25px 10px;
    margin-top:30px;
    border-radius:5px;
    text-align: center;
    overflow: auto;
    position: fixed;
    bottom: 0px;
    width: 100%;
    left: 0px;
    z-index: 1001;
    height: 53px;
    filter:brightness(1.2);
    background: var(--background-color);
}

.row-form{
    width:calc(100% - 10px);
    overflow: auto;
}

.flag-area
{
    position: absolute;
    top: 6px;
    left: 4px;
    padding: 3px;
    border: 1px solid rgb(221, 221, 221);
    display:flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.BookingHours-booking-times div{
    float: left;
    width: 25%;
    height: 100px;
}

.BookingHours-calendar-position {
    margin: 100px 0px 0px 10px;
    background: white;
    overflow: auto;
}

.BookingHours-confirm-btn {
    border: 2px solid black;
    border-radius: 5px;
    filter: brightness(90%);
    padding: 10px;
    font-weight: bold !important;
}

.BookingHours-confirm-btn:hover {
    filter: brightness(70%);
}

@media only screen and (max-width: 1000px) {
    .text-section {
        padding: 15px;
        padding-bottom: 108px;
    }

    .BookingHours-booking-times
    {
        height: 123px;
    }

    #BookingHours-times {
        margin-bottom: 90px;
    }
    .BookingHours-booking-times div{
        float: left;
        width: 33%;
    }

    .g-10 {
        width: 10% !important;
    }

    .g-90 {
        width: 90% !important;
    }

    .BookingHours-calendar-position {
        margin: 40px 20px 0px 20px;
    }

    .mobile-100w-btn {
        width: calc(100% - 10px);
    }
}
</style>
